import {useState, useEffect} from "react";

// wait a specific delay before making last call
export const debounce = (func, delay) => {
  let debounceHandler = null;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(debounceHandler);
    debounceHandler = setTimeout(() => func.apply(context, args), delay);
  };
};

// exec first, ignore later calls for delay
export const throttle = (func, delay) => {
  let inThrottle = false;

  return function () {

    if (!inThrottle) {
      inThrottle = true;

      func.apply(this, arguments);
      setTimeout(() => (inThrottle = false), delay);
    }

  };
};

// https://stackoverflow.com/questions/62135647/react-native-navigation-how-to-refresh-a-route-when-navigating-to-it-via-naviga
// https://dev.to/hieunh1801/react-native-navigation-usefocus-3o2f
export const useFocus = (navigation) => {
  // import {useNavigation} from "@react-navigation/native";
  // const navigation = useNavigation();
  const [isFocused, setIsFocused] = useState(false);
  const [focusCount, setFocusCount] = useState(0);
  const isFirstTime = focusCount === 1;

  useEffect(() => {
    const unsubscribeFocus = navigation.addListener('focus', () => {
      setIsFocused(true);
      setFocusCount(prev => prev + 1);
    });
    const unsubscribeBlur = navigation.addListener('blur', () => {
      setIsFocused(false);
    });

    return () => {
      unsubscribeFocus();
      unsubscribeBlur();
    };
  });

  return {isFocused, isFirstTime, focusCount};
};

export function UseFocusComponent({ navigation, cbForUseEffect, render }) {
  const args = useFocus(navigation);
  useEffect(() => { cbForUseEffect(args) })
  return render && render() || null;
}


